// extracted by mini-css-extract-plugin
export default {"main":"App_main__ysdax","header":"App_header__iEEu6","title":"App_title__bhBJo","navLink":"App_navLink__EdGbo","footer":"App_footer__Zr4ud","footerText":"App_footerText__EuA-7"};